import { Fragment, useState } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-light-svg-icons";
import s from "./filter.module.css";
import { useGTM } from "hooks";

const DropdownSelect = ({
  title,
  icon,
  iconHover,
  value,
  options,
  onChange,
  multiple = true,
}) => {
  const [open, setOpen] = useState(false);
  const { dataLayer } = useGTM();
  const onToggleOpenState = (value) => {
    setOpen(value);
    dataLayer.push({
      event: `cefic_gip_map.filters.dropdown.${value ? "open" : "close"}`,
      filter: title,
    });
  };
  return (
    <Listbox value={value} onChange={onChange} multiple={multiple}>
      <>
        <Listbox.Button
          className={`${value.length ? s.filter_active : ""}  ${
            open ? "bg-primary-200" : ""
          } relative flex flex-col sm:flex-row h-full items-center justify-center cursor-default bg-gray-50 py-2 px-2 sm:pr-6 text-left border-x-gray-200 border-x-1 focus:outline-none  focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm hover:bg-primary-200 w-full`}
          onClick={() => {
            onToggleOpenState(!open);
          }}
        >
          <div className="text-center mx-auto flex flex-col sm:flex-row gap-1 sm:gap-3 items-center">
            {icon}
            {iconHover}
            <p className={`${s.name_listbox_btn}`}>{title}</p>
          </div>
          <FontAwesomeIcon
            icon={faChevronDown}
            className={`transform transition duration-100 text-xs sm:text-base text-gray-300 sm:text-primary-500 ${
              open ? "rotate-180" : "rotate-0"
            }`}
          />
        </Listbox.Button>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="custom-scrollbar text-gray-900 overflow-y-scroll fixed left-0 bottom-[-1%] sm:bottom-inherit sm:absolute z-1200 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base sm:text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            {options?.map((o) => (
              <Listbox.Option key={o.id} value={o.id} as={Fragment}>
                {({ active, selected }) => (
                  <li
                    className={`flex gap-2 items-center py-2 px-4 cursor-pointer select-none font-lato ${
                      active ? "bg-gray-200" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={selected}
                      readOnly={true}
                      className="bg-white-200 hover:bg-amber-400 cursor-pointer w-3 h-3 sm:w-4 sm:h-4 border-3 border-gray-300 rounded checked:!bg-primary-500 !ring-0 !ring-transparent !outline-offset-0"
                    />

                    <span dangerouslySetInnerHTML={{ __html: o.name }} />
                  </li>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </>
    </Listbox>
  );
};

export default DropdownSelect;
